import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ScrollText, ArrowLeft, User, Clock, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/settings`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const fmt = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString('de-CH', { dateStyle: 'medium', timeStyle: 'short' }); }
  catch { return String(iso).slice(0, 16).replace('T', ' '); }
};

export default function SettingsChangeLogPage() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/change-log`, auth())
      .then((r) => setEntries(r.data.entries || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-3xl p-6" data-testid="settings-changelog">
      <button onClick={() => navigate('/settings')} className="mb-4 inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800" data-testid="changelog-back">
        <ArrowLeft className="h-4 w-4" /> Zurück zu Einstellungen
      </button>
      <div className="mb-5 flex items-center gap-2">
        <ScrollText className="h-5 w-5 text-blue-600" />
        <h1 className="text-2xl font-bold text-gray-900">Änderungsprotokoll</h1>
      </div>
      <p className="mb-6 text-sm text-gray-500">Wer hat wann welche Einstellung geändert. Sensible Werte (Schlüssel, Passwörter) werden maskiert.</p>

      {loading ? (
        <div className="flex items-center gap-2 text-gray-500"><Loader2 className="h-4 w-4 animate-spin" /> Lädt…</div>
      ) : entries.length === 0 ? (
        <div className="rounded-xl border border-gray-200 bg-white p-8 text-center text-sm text-gray-400" data-testid="changelog-empty">Noch keine protokollierten Änderungen.</div>
      ) : (
        <ol className="relative space-y-4 border-l border-gray-200 pl-5">
          {entries.map((e) => (
            <li key={e.id} className="relative" data-testid={`changelog-entry-${e.id}`}>
              <span className="absolute -left-[26px] top-1.5 h-2.5 w-2.5 rounded-full bg-blue-500 ring-4 ring-blue-50" />
              <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">{e.section}</span>
                  <span className="inline-flex items-center gap-1 text-xs text-gray-400"><Clock className="h-3 w-3" /> {fmt(e.ts)}</span>
                </div>
                <div className="mt-1.5 inline-flex items-center gap-1 text-xs text-gray-500">
                  <User className="h-3 w-3" /> {e.actor_name || e.actor_email || e.actor_id || 'Unbekannt'}
                </div>
                <ul className="mt-2 space-y-1">
                  {(e.changes || []).map((c, i) => (
                    <li key={i} className="text-sm text-gray-700">
                      <span className="font-medium text-gray-900">{c.field}</span>:
                      <span className="mx-1 text-gray-400 line-through">{c.old === '' ? '(leer)' : c.old}</span>
                      <span className="text-gray-400">→</span>
                      <span className="ml-1 text-gray-800">{c.new}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
